import * as api from '../../api/equityFinder/global';
import { makeApiActionCreatorV3 } from '../utils';

export const PREFERENCE_FETCH_START = 'EQUITYFINDER/PREFERENCE_FETCH_START';
export const PREFERENCE_FETCH_SUCCESS = 'EQUITYFINDER/PREFERENCE_FETCH_SUCCESS';
export const PREFERENCE_FETCH_ERROR = 'EQUITYFINDER/PREFERENCE_FETCH_ERROR';

export const PREFERENCE_PERSIST_START = 'EQUITYFINDER/PREFERENCE_PERSIST_START';
export const PREFERENCE_PERSIST_SUCCESS =
  'EQUITYFINDER/PREFERENCE_PERSIST_SUCCESS';
export const PREFERENCE_PERSIST_ERROR = 'EQUITYFINDER/PREFERENCE_PERSIST_ERROR';

export const FETCH_SYSTEM_CONFIGURATION_START =
  'GLOBAL/FETCH_SYSTEM_CONFIGURATION_START';
export const FETCH_SYSTEM_CONFIGURATION_SUCCESS =
  'GLOBAL/FETCH_SYSTEM_CONFIGURATION_SUCCESS';
export const FETCH_SYSTEM_CONFIGURATION_ERROR =
  'GLOBAL/FETCH_SYSTEM_CONFIGURATION_ERROR';

export const CACHE_REFRESH_START = 'GLOBAL/CACHE_REFRESH_START';
export const CACHE_REFRESH_SUCCESS = 'GLOBAL/CACHE_REFRESH_SUCCESS';
export const CACHE_REFRESH_ERROR = 'GLOBAL/CACHE_REFRESH_ERROR';

export const SELECT_PROPERTY = 'EQUITYFINDER/SELECT_PROPERTY';
export const SELECT_YEAR = 'EQUITYFINDER/SELECT_YEAR';
export const SELECT_CATEGORY = 'EQUITYFINDER/SELECT_CATEGORY';

export const CHECK_IS_CHILD_PROPERTY_START =
  'PROPERTY/CHECK_IS_CHILD_PROPERTY_START';
export const CHECK_IS_CHILD_PROPERTY_SUCCESS =
  'PROPERTY/CHECK_IS_CHILD_PROPERTY_SUCCESS';
export const CHECK_IS_CHILD_PROPERTY_ERROR =
  'PROPERTY/CHECK_IS_CHILD_PROPERTY_ERROR';

export const TOGGLE_MENU = 'EQUITYFINDER/TOGGLE_MENU';

export const fetchPreference = makeApiActionCreatorV3(
  api.fetchPreference,
  PREFERENCE_FETCH_START,
  PREFERENCE_FETCH_SUCCESS,
  PREFERENCE_FETCH_ERROR,
);
export const persistPreference = makeApiActionCreatorV3(
  api.persistPreference,
  PREFERENCE_PERSIST_START,
  PREFERENCE_PERSIST_SUCCESS,
  PREFERENCE_PERSIST_ERROR,
);
export const refreshCache = makeApiActionCreatorV3(
  api.refreshCache,
  CACHE_REFRESH_START,
  CACHE_REFRESH_SUCCESS,
  CACHE_REFRESH_ERROR,
);

export const checkIsChildProperty = makeApiActionCreatorV3(
  api.checkIsChildProperty,
  CHECK_IS_CHILD_PROPERTY_START,
  CHECK_IS_CHILD_PROPERTY_SUCCESS,
  CHECK_IS_CHILD_PROPERTY_ERROR,
);

export const fetchSystemConfiguration = makeApiActionCreatorV3(
  api.fetchSystemConfiguration,
  FETCH_SYSTEM_CONFIGURATION_START,
  FETCH_SYSTEM_CONFIGURATION_SUCCESS,
  FETCH_SYSTEM_CONFIGURATION_ERROR,
);

export function selectProperty(propertyId) {
  return async dispatch => {
    dispatch({ type: SELECT_PROPERTY, data: propertyId });
  };
}

export function selectYear(year) {
  return async dispatch => {
    dispatch({ type: SELECT_YEAR, data: year });
  };
}

export function selectCategory(data) {
  return async dispatch => {
    dispatch({ type: SELECT_CATEGORY, data });
  };
}

export function toggleMenu() {
  return async dispatch => {
    dispatch({ type: TOGGLE_MENU });
  };
}
